<template>
    <v-container text-xs-center te mt-5 pt-5>
        <v-row wrap>
            <v-col xs12 sm="6" md="6" offset-sm3>
                <h1>إضافة طبخة</h1>
            </v-col>
        </v-row>

        <!-- Error Alert -->

        <v-row v-if="error" wrap>
            <v-col xs12 sm="6" md="6" offset-sm3>
                <form-alert :message="error"></form-alert>
            </v-col>
        </v-row>


        <v-row wrap>
            <v-col xs12 offset-sm3>
                    <v-container>
                        <v-form v-model="isFormValid" lazy-validation ref="form" @submit.prevent="handleAddCook">
                            <v-row>
                                <v-col md="6" xs12>
                                    <v-text-field :rules="nameRules" v-model="name" label="اسم الطبخة" required outlined></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row mb-5>
                                <v-col md="6" xs12>
                                    <v-select v-model="cookCountries" :rules="countryRules" :items="countries" multiple label="المطبخ" chips
                                    clearable required outlined></v-select>
                                </v-col>
                            
                                <v-col md="6" xs12>
                                    <v-select v-model="cookCategories" :rules="categoryRules" :items="categories" multiple label="التصنيفات" chips
                                    clearable required outlined></v-select>
                                </v-col>

                                <!-- <v-col md="4" xs12>
                                    <v-select v-model="cookLevels" :rules="levelRules" :items="levels" multiple label="المستوى" chips
                                    clearable required outlined></v-select>
                                </v-col> -->
                            </v-row>

                            <v-row>
                                <v-col xs12>
                                    <v-text-field v-model="videoUrl" :rules="linkRules" label="رابط طريقة التحضير" placeholder="https://youtu.be/u4I8z3HPiB0" required outlined></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row v-if="embedded">
                                <v-col xs12>
                                    <iframe :src="embedded" type="text/html" width="500" height="265" frameborder="0" allowfullscreen></iframe>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col xs12>
                                    <v-autocomplete v-model="cookIngredients" :rules="fullIngRules" :items="ingredients" multiple label="المقادير"  chips
                                    clearable required outlined>
                                    
                                        <template v-slot:selection="data">
                                            <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            close
                                            @click="data.select"
                                            @click:close="remove(data.item)"
                                            >
                                            {{ data.item }}
                                            </v-chip>
                                        </template>
                                        <template v-slot:item="data">
                                            <template v-if="typeof data.item !== 'object'">
                                                <v-list-item-content v-text="data.item"></v-list-item-content>
                                            </template>
                                            <template v-else>
                                            <v-list-item-content>
                                                <v-list-item-title v-html="data.item"></v-list-item-title>
                                            </v-list-item-content>
                                            </template>
                                        </template>
                                    </v-autocomplete>
                                    
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col xs12>
                                    <v-btn :loading="loading" :disabled="!isFormValid || loading" color="secondary" class="black--text" type="submit">
                                        <template v-slot:loader>
                                            <span class="custom-loader">
                                            <v-icon light>mdi-cached</v-icon>
                                            </span>
                                        </template>
                                        إرسال
                                    </v-btn>

                                    <v-btn to="/" color="secondary" class="black--text mx-1" type="cancel">
                                        إلغاء
                                    </v-btn>
                                </v-col>
                            </v-row>

                        </v-form>
                    </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_COUNTRIES } from '../../graphql/Countries'
import { GET_CATEGORIES } from '../../graphql/Categories'
import { GET_LEVELS } from '../../graphql/Levels'
import { GET_INGREDIENTS } from '../../graphql/Ingredients'


export default {
    name: 'AddCook',
    data() {
        return {
            isFormValid: true,
            name: "",
            cookCountries: [],
            cookCategories: [],
            cookLevels: [],
            cookIngredients: [],
            videoUrl: "",
            embedded: "",
            nameRules: [
                // Check if name in input
                name => !!name || "الاسم مطلوب",
                // Make sure name is less than 10 char
                name => name.length < 40 || "الاسم يجب أن لا يتجاوز الأربعين حرف"
            ],
            countryRules: [
                // Check if country in input
                country => country.length > 0 || "البلد مطلوب"
            ],
            categoryRules: [
                // Check if category in input
                category => category.length > 0 || "التصنيف مطلوب"
            ],
            // levelRules: [
            //     // Check if level in input
            //     level => level.length > 0 || "المستوى مطلوب"
            // ],
            fullIngRules: [
                // Check if ingredients in input
                ingre => ingre.length > 0 || "المقادير مطلوبة"
            ],
            linkRules: [
                // Check if link in input
                link => !!link || "الرابط مطلوب",
                link => this.validateYouTubeUrl(link)
            ]
        }
    },
    apollo: {
        countries: {
            query: GET_COUNTRIES,
            update: data => data.countries.map(p => p.name)     
        },
        categories: {
            query: GET_CATEGORIES,
            update: data => data.categories.map(p => p.name)
        },
        ingredients: {
            query: GET_INGREDIENTS,
            update: data => data.ingredients.map(p => p.name)
        },
    },
    computed: {
        ...mapGetters(['user', 'loading', 'error', 'setSuccessMessage'])
    },
    watch: {
        user(value) {
            // If user value changes, redirect to home page
            if(!value) {
                this.$router.push('/signin')
            }
        }
    },
    methods: {
        handleAddCook() {
            if(this.$refs.form.validate()) {
                this.$store.dispatch('addCook', {
                    name: this.name,
                    countries: this.cookCountries,
                    categories: this.cookCategories,
                    videoUrl: this.embedded,
                    ingredients: this.cookIngredients,
                    createdBy: this.user.id
                })
            }
        },
        remove (item) {
            const index = this.cookIngredients.indexOf(item)
            if (index >= 0) this.cookIngredients.splice(index, 1)
        },
        validateYouTubeUrl(url) {    
            if (url != undefined || url != '') {        
                var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
                var match = url.match(regExp);
                if (match && match[2].length == 11) {
                    // Do anything for being valid
                    // if need to change the url to embed url then use below line            
                   this.embedded = 'https://www.youtube.com/embed/' + match[2] + '?enablejsapi=1'
                   return true
                } else {
                    return 'NOT VALID'
                    // Do anything for not being valid
                }
            }
        }
    }
}
</script>

